module.exports = __webpack_public_path__ + "img/defaultNep11.c46452d4.png";